import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createSlots as _createSlots, withKeys as _withKeys } from "vue"

const _hoisted_1 = { class: "custom-sidebar" }
const _hoisted_2 = { class: "sidebar-header pa-1 pl-3" }
const _hoisted_3 = { class: "sidebar-header-actions" }
const _hoisted_4 = { class: "history-list" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["title"]
const _hoisted_7 = { class: "history-item-actions" }
const _hoisted_8 = {
  ref: "agentSelect",
  class: "agent-select-inline"
}
const _hoisted_9 = {
  key: 0,
  class: "mr-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_PublicAgentChat = _resolveComponent("PublicAgentChat")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_ConfirmationDialog = _resolveComponent("ConfirmationDialog")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    ref: "dashboardContainer",
    class: "dashboard-chat-container pa-0 ma-0",
    fluid: ""
  }, {
    default: _withCtx(() => [
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_v_row, {
            key: 0,
            justify: "center",
            class: "mt-16"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_progress_circular, {
                indeterminate: "",
                size: "64"
              })
            ]),
            _: 1
          }))
        : (!_ctx.hasPublishedAgents)
          ? (_openBlock(), _createBlock(_component_v_row, {
              key: 1,
              justify: "center",
              class: "mt-16"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "12",
                  class: "text-center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, {
                      size: "64",
                      color: "primary",
                      class: "mb-4"
                    }, {
                      default: _withCtx(() => _cache[7] || (_cache[7] = [
                        _createTextVNode("mdi-robot-outline")
                      ])),
                      _: 1,
                      __: [7]
                    }),
                    _cache[9] || (_cache[9] = _createElementVNode("h2", { class: "text-h5 mb-2" }, "No Published Agents", -1)),
                    _cache[10] || (_cache[10] = _createElementVNode("p", { class: "text-body-1" }, "You need to publish at least one agent to use the chat feature.", -1)),
                    _createVNode(_component_v_btn, {
                      color: "primary",
                      onClick: _ctx.navigateToAgents,
                      class: "mt-4"
                    }, {
                      default: _withCtx(() => _cache[8] || (_cache[8] = [
                        _createTextVNode(" Go to Agents ")
                      ])),
                      _: 1,
                      __: [8]
                    }, 8, ["onClick"])
                  ]),
                  _: 1,
                  __: [9,10]
                })
              ]),
              _: 1
            }))
          : (_openBlock(), _createBlock(_component_v_row, {
              key: 2,
              class: "ma-0 chat-body-row"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, {
                  cols: "12",
                  class: "pa-0 d-flex chat-body-col"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                      _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                          _createVNode(_component_v_btn, {
                            color: "primary",
                            onClick: _ctx.startNewChat,
                            variant: "text",
                            icon: "mdi-note-plus-outline",
                            size: "small"
                          }, null, 8, ["onClick"]),
                          _createVNode(_component_v_btn, {
                            color: "primary",
                            variant: "text",
                            icon: _ctx.hideWorkflowChatsInHistory ? 'mdi-filter-minus-outline' : 'mdi-filter-outline',
                            size: "small",
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleHideWorkflowChatsInHistory(!_ctx.hideWorkflowChatsInHistory)))
                          }, null, 8, ["icon"])
                        ]),
                        _createVNode(_component_v_tooltip, {
                          text: "Retry failed responses once when no tool ran and no assistant content was produced.",
                          location: "right"
                        }, {
                          activator: _withCtx(({ props }) => [
                            _createElementVNode("div", _mergeProps(props, { class: "auto-retry-toggle" }), [
                              _createVNode(_component_v_checkbox, {
                                "model-value": _ctx.autoRetryFailedChatResponses,
                                label: "Auto Retry",
                                density: "compact",
                                "hide-details": "",
                                color: "primary",
                                "onUpdate:modelValue": _ctx.onAutoRetryToggle
                              }, null, 8, ["model-value", "onUpdate:modelValue"])
                            ], 16)
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_4, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chatHistory, (chat) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: chat.id,
                            onClick: ($event: any) => (_ctx.openChat(chat.id)),
                            class: _normalizeClass(["history-item", { 'active': chat.id === _ctx.currentChatId }])
                          }, [
                            _createElementVNode("span", {
                              class: "history-item-title",
                              title: chat.title
                            }, _toDisplayString(chat.title), 9, _hoisted_6),
                            _createElementVNode("div", _hoisted_7, [
                              _createVNode(_component_v_tooltip, { location: "top" }, {
                                activator: _withCtx(({ props: tooltip }) => [
                                  _createVNode(_component_v_icon, _mergeProps({ ref_for: true }, tooltip, {
                                    onClick: _withModifiers(($event: any) => (_ctx.startEditChat($event, chat.id, chat.title)), ["stop"]),
                                    size: "small",
                                    color: "primary"
                                  }), {
                                    default: _withCtx(() => _cache[11] || (_cache[11] = [
                                      _createTextVNode(" mdi-pencil-outline ")
                                    ])),
                                    _: 2,
                                    __: [11]
                                  }, 1040, ["onClick"])
                                ]),
                                default: _withCtx(() => [
                                  _cache[12] || (_cache[12] = _createElementVNode("span", null, "Edit", -1))
                                ]),
                                _: 2,
                                __: [12]
                              }, 1024),
                              (!_ctx.isAutomationChat(chat))
                                ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                    key: 0,
                                    location: "top"
                                  }, {
                                    activator: _withCtx(({ props: tooltip }) => [
                                      _createVNode(_component_v_icon, _mergeProps({ ref_for: true }, tooltip, {
                                        onClick: _withModifiers(($event: any) => (_ctx.handleDeleteClick($event, chat.id)), ["stop"]),
                                        size: "small",
                                        color: "primary",
                                        class: "ml-2"
                                      }), {
                                        default: _withCtx(() => _cache[13] || (_cache[13] = [
                                          _createTextVNode(" mdi-delete-forever-outline ")
                                        ])),
                                        _: 2,
                                        __: [13]
                                      }, 1040, ["onClick"])
                                    ]),
                                    default: _withCtx(() => [
                                      _cache[14] || (_cache[14] = _createElementVNode("span", null, "Delete", -1))
                                    ]),
                                    _: 2,
                                    __: [14]
                                  }, 1024))
                                : _createCommentVNode("", true)
                            ])
                          ], 10, _hoisted_5))
                        }), 128))
                      ])
                    ]),
                    _createVNode(_component_v_col, {
                      ref: "chatContentArea",
                      class: "pa-0 d-flex flex-column overflow-hidden chat-content-area"
                    }, {
                      default: _withCtx(() => [
                        (_ctx.currentChat && _ctx.currentAgentDetails)
                          ? (_openBlock(), _createBlock(_component_PublicAgentChat, {
                              key: _ctx.currentChat.id,
                              agent: _ctx.currentAgentDetails,
                              session: _ctx.currentChat,
                              "scroll-debug": _ctx.dashboardScrollDebugEnabled,
                              "auto-retry-failed-responses": _ctx.autoRetryFailedChatResponses,
                              "initial-message": _ctx.pendingInitialMessage || '',
                              onInitialMessageConsumed: _cache[2] || (_cache[2] = ($event: any) => (_ctx.pendingInitialMessage = null))
                            }, {
                              "agent-selector": _withCtx(() => [
                                _createElementVNode("div", _hoisted_8, [
                                  _createVNode(_component_v_select, {
                                    modelValue: _ctx.selectedAgentKey,
                                    "onUpdate:modelValue": [
                                      _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedAgentKey) = $event)),
                                      _ctx.onAgentChange
                                    ],
                                    items: _ctx.publishedAgentItems,
                                    "item-title": "name",
                                    "item-value": "key",
                                    label: _ctx.selectedAgentKey ? '' : 'Select Agent',
                                    variant: "underlined",
                                    density: "compact",
                                    slim: "",
                                    disabled: _ctx.loading,
                                    "hide-details": ""
                                  }, {
                                    item: _withCtx(({ props, item }) => [
                                      _createVNode(_component_v_list_item, _mergeProps(props, {
                                        title: item.raw.name,
                                        subtitle: item.raw.isShared ? `${item.raw.description} (shared by @${item.raw.ownerUsername})` : item.raw.description
                                      }), _createSlots({ _: 2 }, [
                                        (item.raw.isShared)
                                          ? {
                                              name: "prepend",
                                              fn: _withCtx(() => [
                                                _createVNode(_component_v_icon, {
                                                  size: "small",
                                                  color: "primary"
                                                }, {
                                                  default: _withCtx(() => _cache[15] || (_cache[15] = [
                                                    _createTextVNode("mdi-share-variant")
                                                  ])),
                                                  _: 1,
                                                  __: [15]
                                                })
                                              ]),
                                              key: "0"
                                            }
                                          : undefined
                                      ]), 1040, ["title", "subtitle"])
                                    ]),
                                    selection: _withCtx(({ item }) => [
                                      (item.raw.isShared)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_9, [
                                            _createVNode(_component_v_icon, {
                                              size: "small",
                                              color: "primary"
                                            }, {
                                              default: _withCtx(() => _cache[16] || (_cache[16] = [
                                                _createTextVNode("mdi-share-variant")
                                              ])),
                                              _: 1,
                                              __: [16]
                                            })
                                          ]))
                                        : _createCommentVNode("", true),
                                      _createElementVNode("span", null, _toDisplayString(item.raw.name), 1)
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue", "items", "label", "onUpdate:modelValue", "disabled"])
                                ], 512)
                              ]),
                              _: 1
                            }, 8, ["agent", "session", "scroll-debug", "auto-retry-failed-responses", "initial-message"]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 512)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })),
      _createVNode(_component_v_dialog, {
        modelValue: _ctx.showEditDialog,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.showEditDialog) = $event)),
        "max-width": "400"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_title, null, {
                default: _withCtx(() => _cache[17] || (_cache[17] = [
                  _createTextVNode("Edit Chat Name")
                ])),
                _: 1,
                __: [17]
              }),
              _createVNode(_component_v_card_text, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field, {
                    modelValue: _ctx.editingTitle,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.editingTitle) = $event)),
                    label: "Chat Name",
                    variant: "outlined",
                    autofocus: "",
                    onKeyup: _withKeys(_ctx.saveEditChat, ["enter"])
                  }, null, 8, ["modelValue", "onKeyup"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_card_actions, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_spacer),
                  _createVNode(_component_v_btn, {
                    text: "",
                    onClick: _ctx.cancelEditChat
                  }, {
                    default: _withCtx(() => _cache[18] || (_cache[18] = [
                      _createTextVNode("Cancel")
                    ])),
                    _: 1,
                    __: [18]
                  }, 8, ["onClick"]),
                  _createVNode(_component_v_btn, {
                    color: "primary",
                    variant: "flat",
                    onClick: _ctx.saveEditChat
                  }, {
                    default: _withCtx(() => _cache[19] || (_cache[19] = [
                      _createTextVNode("Save")
                    ])),
                    _: 1,
                    __: [19]
                  }, 8, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_ConfirmationDialog, {
        modelValue: _ctx.showDeleteConfirmation,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.showDeleteConfirmation) = $event)),
        title: "Confirm Delete",
        message: "Are you sure you want to delete this chat history? This action cannot be undone.",
        loading: false,
        onConfirm: _ctx.executeDeleteChat,
        onCancel: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showDeleteConfirmation = false))
      }, null, 8, ["modelValue", "onConfirm"])
    ]),
    _: 1
  }, 512))
}